import {Component, OnInit} from '@angular/core';
import {IndicatorBoxModel} from '../../../../models/indicator-box.model';
import {IndicatorsSearchToolbarModel} from '../../../../models/indicators-search-toolbar-model.model';
import {IndicatorsChartService, IndicatorsService} from '../../../../services/indicators/indicators.service';
import {SearchToolbarModelFactoryService} from '../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import {
  SearchToolbarDateFunction,
  SearchToolbarFactoryParameters, SearchToolbarFilterGrouping, SearchToolbarFilterWindow, SearchToolbarSection
} from '../../../../models/search-toolbar-factory-parameters.model';
import {AnalyticsService} from '../../../../services/analytics/analytics.service';
import {QFilterModel} from '../../../../models/qfilter.model';
import {TranslateService} from '@ngx-translate/core';
import {DataTableField} from '../../../../modules/UIKit/components/dataTable/dataTableField.interface';
import {StoreCampaignService} from '../../../../services/store/stores-campaign.service';

import {Observable} from 'rxjs/Observable';
import { LoyaltyChart } from '../../../../models/loyalty-chart-config.model';

@Component({
  selector: 'app-shop-overview-main-kpi',
  templateUrl: './shop-overview-main-kpi.component.html',
  styleUrls: ['./shop-overview-main-kpi.component.css']
})

//Pagina 20
export class ShopOverviewMainKpiComponent implements OnInit {
  show_results = false;

  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
  public indicators: IndicatorBoxModel[] = [];
  storesListTitles: DataTableField[];
  translations: any;
  public date_from: Date;
  public date_to: Date;
  public selectedStore: any;
  public data: QFilterModel;
  public overviweChart: LoyaltyChart;
  public mapChart = [];
  lat: number = 51.673858;
  lng: number = 7.815982;

  constructor (
    private indicatorService: IndicatorsService,
    public srvStoreCampaign: StoreCampaignService,
    private searchModelFactory: SearchToolbarModelFactoryService,
    private svcAnalytics: AnalyticsService,
    private chartsService: IndicatorsChartService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.translate.get([
      'stores.overview_fatturato_pvd',
      'stores.fatturato',
      'stores.overview_fatturato_pvd_chart_x_title',
      'stores.overview_fatturato_pvd_chart_y_title',
      'stores.mappa'
    ]).subscribe((t) => {
      this.translations = {
        overview_fatturato_pvd: t['stores.overview_fatturato_pvd'],
        fatturato: t['stores.fatturato'],
        chart_x_title: t['stores.overview_fatturato_pvd_chart_x_title'],
        chart_y_title: t['stores.overview_fatturato_pvd_chart_y_title'],
        mappa: t['stores.mappa']
      };
      this.initCharts();
    });

  }

  initCharts() {
    this.overviweChart = (new LoyaltyChart('bubble'));
    this.overviweChart.options.plotOptions = { series: { dataLabels: { enabled: true, format: '{point.name}' } } };
    this.overviweChart.options.yAxis.labels.formatter = function() {
      return this.value + '%';
    };
    this.overviweChart.options.yAxis.title.text = this.translations.chart_y_title;
    this.overviweChart.options.xAxis.title.text = this.translations.chart_x_title;
    this.overviweChart.options.xAxis.labels.format = '{value} €';

    this.overviweChart.options.chart.height = 450;
    this.overviweChart.options.chart.zoomType = 'xy';
    this.overviweChart.options.tooltip = {
      useHTML: true,
      headerFormat: '<table>',
      pointFormat:
        '<tr><th colspan="2">{point.name}</th></tr>' +
        '<tr><th>' + this.translations.fatturato + ':</th><td>{point.z} €</td></tr>' +
        '<tr><th>' + this.translations.chart_x_title + ':</th><td>{point.x} €</td></tr>' +
        '<tr><th>' + this.translations.chart_y_title + ':</th><td>{point.y} %</td></tr>',
      footerFormat: '</table>',
      followPointer: true
    };
  }

  setChartInstance(chart: LoyaltyChart, chartInstance) {
    chart.instance = chartInstance;
  }

  searchValue(data: QFilterModel) {
    this.data = data;

    this.indicators = [];

    Observable.zip(
      this.indicatorService.indicatorCalculation('stores.Q071', this.data),
      this.indicatorService.indicatorCalculation('stores.Q072', this.data)
    ).subscribe(
      (r) => {

        const indicators = [];

        r.forEach(function(rc) { rc.forEach(function(i) { indicators.push(i); }) });

        this.indicators.push(new IndicatorBoxModel(indicators.filter((ind) => ind.name === 'numero_negozi'), {dynamic: true, decimal_value: 0, decimal_prec_value: 0}));
        this.indicators.push(new IndicatorBoxModel(indicators.filter((ind) => ind.name === 'nuove_aperture'), {dynamic: true, decimal_value: 0, decimal_prec_value: 0}));
        this.indicators.push(new IndicatorBoxModel(indicators.filter((ind) => ind.name === 'fatturato'), {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '€'}));
        this.indicators.push(new IndicatorBoxModel(indicators.filter((ind) => ind.name === 'fatturato_mq'), {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '€'}));
      });

    this.overviweChartInit (data);
    this.mapChartInit (data);
    this.show_results = true
  }

  overviweChartInit (data) {
    this.indicatorService.getChart('stores.Q138', data,false).subscribe( res => {

      if (res.series.length < 4) {
        return;
      }

      if (this.overviweChart.instance) {
        while (this.overviweChart.instance.series.length > 0) {
          this.overviweChart.instance.series[0].remove(true);
        }
      }

      let minY = 0;
      const data_act = [];
      for (let i = 0; i < res.series[0].serie.length; i++) {
        data_act.push({ x: res.series[1].serie[i], y: res.series[2].serie[i], z: res.series[3].serie[i], name: res.series[0].serie[i] });
        minY = res.series[2].serie[i] < minY ? res.series[2].serie[i] : minY;
      }

      this.overviweChart.options.yAxis.min = minY;

      this.overviweChart.instance.addSeries(
        {
          name: this.translations.fatturato,
          data: data_act,
          color: LoyaltyChart.colors[1]
        }
      );

      this.overviweChart.instance.update(this.overviweChart.options);
      this.overviweChart.instance.redraw();

    });

  }




  mapChartInit (data) {

    Observable.zip(
      this.indicatorService.getChart('stores.Q139', data, false)
    ).subscribe( ([res]) => {

      let latMin = 1000;
      let lngMin = 1000;
      let latMax = -1000;
      let lngMax = -1000;
      this.mapChart = [];

      for (let i = 0; i < res.series[0].serie.length; i++) {
        this.mapChart.push ({name: res.series[0].serie[i], lat: res.series[1].serie[i], lng: res.series[2].serie[i]});
        latMin = Math.min (res.series[1].serie[i], latMin);
        lngMin = Math.min (res.series[2].serie[i], lngMin);
        latMax = Math.max (res.series[1].serie[i], latMax);
        lngMax = Math.max (res.series[2].serie[i], lngMax);
        this.lat += res.series[1].serie[i];
        this.lng += res.series[2].serie[i];
      }
      this.lat = (latMin + latMax) / 2;
      this.lng = (lngMin + lngMax) / 2;

    });

  }
  resetData() {
    this.show_results = false;
  }


}



// WEBPACK FOOTER //
// ./src/app/views/store/panoramica/shop-overview-main-kpi/shop-overview-main-kpi.component.ts